import { render, staticRenderFns } from "./DisplayTemperatureData.vue?vue&type=template&id=74646ddd&"
import script from "./DisplayTemperatureData.vue?vue&type=script&lang=js&"
export * from "./DisplayTemperatureData.vue?vue&type=script&lang=js&"
import style0 from "./DisplayTemperatureData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports